import React, { FC, ReactElement, useState } from "react";
import AIModal from "../../elements/AIModal";
import { default as arrow} from "../../../AE2/static/icons/needs_attention/Side Arrow.svg"
import { IonButton, IonIcon, IonItem, IonLabel, IonList } from "@ionic/react";
import { API_URL } from "../../../actions/settings";
import LoadingDots from "../../extras/LoadingDots";

async function getData(token: string, id: string) {
  return fetch(`${API_URL}/homepage/needs_attention/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log(err)
                return null
            })

        }
      }).catch(error => {
        console.log(error)
        return null
      });
}

interface IProps {
    id: string;
    title: ReactElement;

};

interface DataItem {
    id: string;
    type:string;
    building: string;
    customer?: string;
    detail:string;
 
}

const NeedsAttentionModal:FC<IProps> = (props) => {
    const [opened, setOpened] = useState(false)
    const [data, setData] = useState<null|DataItem[]>(null)
    const [loading,setLoading] = useState(true)
    
    const handleData = async () => {
        if(!data){
            setLoading(true)
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            const res = await getData(token, props.id)
            if(!res){
                setData(null)
                setLoading(false)
            }
            setData(res.data)
            setLoading(false)
        }
    }


    return  <div>
        <IonButton fill="clear" slot="end" onClick={()=>setOpened(true)}>
        <IonIcon className="pointer" src={arrow} />
        </IonButton>
        <AIModal title={props.title} opened = {opened} setOpened={setOpened} onLoad={()=>handleData()} >
            <div style={{width:'100%',textAlign:'center'}}>
                {loading ? 
                <div>
                    <LoadingDots/>
                </div> :
                <div>
                    
                    {data?.length && data?.length > 0 ? 
                    <IonList>
                        {data.map((item: DataItem) => (
                            <IonItem  key={item.id} href={`/?id=${item.id}&sec=${item.type}`}>
                                <IonLabel><div>
                                        <div>{item.building} ({item.detail})</div>
                                        <div className="text-footer-blue font-11pt">{item.customer}</div>
                                    </div>
                                    </IonLabel>
                                    <IonIcon className="pointer" src={arrow}/>                                
                            </IonItem>
                        ))}
  
                    </IonList>: <div>None</div>}
                </div>
                }
            </div>
        </AIModal>
    </div>
};

export default NeedsAttentionModal;